module.exports = __webpack_public_path__ + "img/img3.13c9194e.png";